import Card from "../Card"
import SmallHeadingComponent from "../SmallHeadingComponent"
import Link from "../Link"
import {
    NAVIGATION_VIEW,
    NavigationPaths
} from "../../navigation/NavigationController"
import SmallestHeadingComponent from "../SmallestHeadingComponent"
import ProfessionalIcon from "../ProfessionalIcon"
import PatientIcon from "../PatientIcon"

function PokalPlatform() {
    return (
        <Card width={"100%"} fill={true}>
            <div className={"flex flex-col space-y-4"}>
                <SmallHeadingComponent>DOOR Connect Online</SmallHeadingComponent>
                <div>
                    Die DOOR Connect Online Seite bereitet Patient:innen-Daten auf und
                    bietet Ärzt:innen umfangreiche Methoden der Datenanalyse und
                    Datenvisualisierung.
                </div>
                <div>
                    Daneben dient sie{" "}
                    <b>
                        sowohl für Patient:innen als auch für Ärzt:innen als
                        Anlaufstelle für Hilfe und Dokumentation
                    </b>{" "}
                    der Platform selbst so wie der Applikationen DOOR Studie Connect
                    App und DOOR Studie MedScan App.
                </div>
                <div className={"flex flex-col space-y-2"}>
                    <SmallestHeadingComponent>
                        Grundsätzliches
                    </SmallestHeadingComponent>
                    Die DOOR Studie Platform richtet sich zum Teil sowohl an
                    Patient:innen als auch an Ärzt:innen. Bereiche die sich nur
                    an eine der beiden Nutzergruppen richten sind mit den
                    folgenden Icons markiert:
                    <div className={"flex items-center space-x-2"}>
                        <ProfessionalIcon />
                        <div>Inhalt richtet sich an Ärzt:innen</div>
                    </div>
                    <div className={"flex items-center space-x-2"}>
                        <PatientIcon />
                        <div>Inhalt richtet sich an Patient:innen</div>
                    </div>
                </div>
                <div className={"flex flex-col space-y-2"}>
                    <SmallestHeadingComponent>
                        Downloads & Links
                    </SmallestHeadingComponent>
                    <Link to={NavigationPaths[NAVIGATION_VIEW.SIGN_IN].path}>
                        Sie haben bereits ein Konto? Jetzt anmelden
                    </Link>
                    <Link to={NavigationPaths[NAVIGATION_VIEW.SIGN_UP].path}>
                        Sie möchten sich als neuer Nutzer registrieren? Jetzt
                        registrieren
                    </Link>
                </div>
            </div>
        </Card>
    )
}

export default PokalPlatform
